module.exports = __webpack_public_path__ + "img/delivery-box.0e3a9043.png";